import { MutationTree } from "vuex";
import { IDataProvider } from "@/store";
import { IReportState } from "@/store/modules/report/state";
import { DocumentReportListItem } from "@/types/report/ReportTypes";

export enum ReportMutations {
  SET_ONE = "SET_ONE_REPORT",
  SET_ALL = "SET_ALL_REPORT",
  SET_LAZY_DATA = "SET_LAZY_DATA_REPORT",
}

export const mutations: MutationTree<IReportState> = {
  [ReportMutations.SET_ONE](state, payload: DocumentReportListItem) {
    state.report = payload;
  },
  [ReportMutations.SET_ALL](state, payload: DocumentReportListItem[]) {
    state.reports = payload;
  },
  [ReportMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<DocumentReportListItem>
  ) {
    state.dataProvider = payload;
  },
};
